import useCustomQuery from './useCustomQuery';

export const payoutClaimsQueryKey = (accountId) => `payoutClaims-${accountId}`;

// One request per account page: every transaction row shares this query key.
const usePayoutClaims = (accountId, enabled = true) => useCustomQuery({
  httpMethod: 'GET',
  path: `account/${accountId}/payout-claims`,
  key: payoutClaimsQueryKey(accountId),
  errorMessage: 'Failed to load payout claims',
  enabled: !!accountId && enabled,
});

export default usePayoutClaims;
